import { Component, OnInit } from '@angular/core';
import { RegistrationService } from '../../registration.service';

 //import { FormGroup, FormControl, NgForm} from '@angular/forms';
 //import { forEach } from '@angular/router/src/utils/collection';
import swal from 'sweetalert2';
import { HandleError } from '../../shared/HandleError';

@Component({
  selector: 'app-basic-reg-from-view',
  templateUrl: './basic-reg-from-view.component.html',
  styleUrls: ['./basic-reg-from-view.component.css']
})
export class BasicRegFromViewComponent implements OnInit {

  SP: any={};
  SU: any={};
  SBC: any={};
  SB: any={};
  SD: any={};
  SA : any={};
  SR: any={};
  S: any={};
  title="Sainik Details - New Format";
  data: any;
  sainikDetails:any;
  s:any={};
  UserName: string;
  RoleName: string;
  show: number=0;
  Formdiable: boolean=false;
  dp: any;

  

  constructor(private service: RegistrationService,private handleError:HandleError) { }


  ngOnInit() {
    this.UserName=localStorage.getItem('userName');
    this.RoleName=localStorage.getItem('userRole');
    if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
    this.s.SR_ServiceNo=this.UserName;
    // this.GetSainikBasicDetails(this.s.SR_ServiceNo)
    this.GetSainikDetailsFromRegistration(this.s.SR_ServiceNo)
    }
  }

  // Back(){
  //     window.location.href='/home/br';   
  // }

  InsertFinalize(ServiceNo){
    debugger;
    // alert(this.s.SR_PA_Pincode.getRawValue());
       document.getElementById('loader-spinner').style.display = "block";
       this.data = this.service.insertFinalize(ServiceNo);
       this.data.subscribe(
         (response) => {
           swal('Success!', 'Sainik details saved successfully.Your details cannot be edited further till it is Approved.', 'success');
           this.Formdiable=true;
           document.getElementById('loader-spinner').style.display = "none";
           // window.location.href='http://sainik.esdinfra.com/index.html#/';
         }, (error) => {
           console.log(error);
           document.getElementById('loader-spinner').style.display = "none";
           // if(error.status == 401)
           // swal('Warning!', 'Not authorized to access this page.', 'warning');
            this.handleError.ErrorHandler(error);
         });
  }

  GetSainikDetailsFromRegistration(SR_ServiceNo){
    debugger;
    this.show=1;
    if(this.CheckRequired(SR_ServiceNo))
    {   
    //this.SBC.reset(); 
    // this.SBC.SBC_Date='';
    this.data = this.service.getSainikCompleteDetails(SR_ServiceNo);    
    this.data.subscribe(
      (response:any) => {   
        //this.menuList=JSON.parse(this.menuList);   
        this.S=response;
        this.SR=response.SainikRegistration;
        this.SA=response.SainikAwards;
        this.SD=response.SainikDependents;
        this.SB=response.SainikBankDetails;
        this.SBC=response.SainikBattleCasualty;
        this.SP=response.SainikPension;
        this.SU=response.SainikUploads;
        if(this.SR.SR_OA_Pincode==0||this.SR.SR_OA_Pincode==undefined)
        this.SR.SR_OA_Pincode=null;
        if(this.SR.SR_Pincode==0||this.SR.SR_Pincode==undefined)
        this.SR.SR_Pincode=null;
       for(let i=0;i<this.SU.length;i++){
         if(this.SU[i].DocumentTypes.IsSelected==1){
          this.SU[i].DocumentTypes.IsSelected=true; 
         }
        // if(this.SU[i].DocumentTypes.DT_Name=='FingerPrint'){
        //  this.SR.SR_FingerPrint=this.SU[i].ImagePath;
        // }
       // console.log(this.SP);
       }
      }, (error) => {
        console.log(error);
        if (error.status == 400)
        swal('Warning!', 'Sainik does not exist', 'warning');
        
        //swal('Warning!', 'Sainik does not exist.', 'warning');
        //swal('Warning!', 'Sainik does not belong to this district or Sainik does not exist .', 'warning');
        // else if(error.status == 401)
        //   swal('Warning!', 'Not authorized to access this page.', 'warning');
        this.handleError.ErrorHandler(error);
      });
    }
    else
    swal('Warning!', 'Please Enter the Service no.', 'warning');
  }

  CheckRequired(value) {
    if (typeof (value) != undefined && value != '' && value != null)
      return true;
    else
      return false;
  }

  GetSainikCompleteDetails(SR_ServiceNo){
    debugger;
    if(this.CheckRequired(SR_ServiceNo))
    {   
    //this.SBC.reset(); 
    this.data = this.service.getSainikCompleteDetails(SR_ServiceNo);    
    this.data.subscribe(
      (response:any) => {   
        //this.menuList=JSON.parse(this.menuList);   
        this.S=response;
        this.SR=response.SainikRegistration;
        this.SA=response.SainikAwards;
        this.SD=response.SainikDependents;
        if(response.SainikBankDetails!=null){
        this.SB=response.SainikBankDetails;
        }
        if(response.SainikPension!=null){
        this.SP=response.SainikPension;
        }
        if(response.SainikBattleCasualty!=null){
        this.SBC=response.SainikBattleCasualty;
        }
        this.SU=response.SainikUploads;
        if(this.SR.SR_OA_Pincode==0||this.SR.SR_OA_Pincode==undefined)
        this.SR.SR_OA_Pincode=null;
         if(this.SR.SR_Pincode==0||this.SR.SR_Pincode==undefined)
         this.SR.SR_Pincode=null;
         if(this.SR.SR_PA_Pincode==0||this.SR.SR_PA_Pincode==undefined)
         this.SR.SR_PA_Pincode=null;
            for(let i=0;i<this.SU.length;i++){
                        if(this.SU[i].DocumentTypes.IsSelected==1){
                          this.SU[i].DocumentTypes.IsSelected=true; 
         }
        // if(this.SU[i].DocumentTypes.DT_Name=='FingerPrint'){
        //  this.SR.SR_FingerPrint=this.SU[i].ImagePath;
        // }
       // console.log(this.SP);
       }
      }, (error) => {
        console.log(error);
        if (error.status == 400){      
        if(this.RoleName=="Super Admin"){
          swal('Warning!', 'Sainik does not exist, Please fill the details', 'warning');
        }
        else{
        swal('Warning!', 'Sainik does not belong to this district or Sainik does not exist', 'warning');
         }
        }     
        //swal('Warning!', 'Sainik does not exist.', 'warning');
       // swal('Warning!', 'Sainik does not belong to this district or Sainik does not exist .', 'warning');
        // else if(error.status == 401)
        //   swal('Warning!', 'Not authorized to access this page.', 'warning');
        this.handleError.ErrorHandler(error);
      });
    }
    else
    swal('Warning!', 'Please Enter the Service no.', 'warning');
  }


  // ChangeCheckBoxForSU(){
  //   debugger;
  //   if(this.SU.DocumentTypes.IsSelected==0)
  //   this.SU.DocumentTypes.IsSelected = false;
  //   else {
  //     this.SU.DocumentTypes.IsSelected = true;
  // }
//}



}



// WEBPACK FOOTER //
// ./src/app/sainik-registration/basic-reg-from-view/basic-reg-from-view.component.ts